module.exports = __webpack_public_path__ + "static/media/commodities_01.f08cd9ba.jpg";